import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    Form,
    Col,
    message,
    Progress
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import {
    PaperClipOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined
} from '@ant-design/icons'
// import PasswordStrengthBar from 'react-password-strength-bar';
import zxcvbn from 'zxcvbn';
import moment from 'moment';

const {Option, OptGroup} = Select;

class XmView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            value:0,
            visible: false,
            loading: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        this.props.NAV_CHANGE('/geren', ['首页', '密码修改'])
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, that.state.condition, {[name]: value})
        that.setState({
            condition: data
        })
        if (name == 'new_password1') {
            that.setState({
                value: zxcvbn(value).guesses_log10
            })
        }
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={Number(item.id)} key={index}>{item.name}</Option>
            )
        }
    }

    //判断密码强度
    // pssschange(score, feedback){
    //     console.log(score, feedback)
    //     this.setState({
    //         score:score
    //     })
    // }
    sub() {
        let that = this
        // if (that.state.pwd_lv == -1) {
        //     message.error('新密码安全等级弱！');
        //     return;
        // }
        that.setState({
            loading: true
        })
        fetch('/Geren/dopassword', {
            method: "POST",
            body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    that.setState({
                        condition: {
                            id: that.props.id,
                        }
                    })
                } else {
                    message.error(data.msg)
                }
                that.setState({
                    loading: false
                })
            })
    }

    getPwdValueAndColor = (value, type) => {
        let that = this
        var hasNumber = /\d/.test(value);
        var hasLetter = /[a-zA-Z]/.test(value);
        var hasSymbol = /[^A-Za-z0-9]/.test(value);
        if (value) {
            value = String(value)
            if (type === 1) {
                if (value.length < 6) {
                    return 33.33333
                }
                let num = 0;
                if (hasNumber) {
                    num = num + 33.33333
                }
                if (hasLetter) {
                    num = num + 33.33333
                }
                if (hasSymbol) {
                    num = num + 33.33333
                }
                if (num === 99.99999) {
                    num = 100
                }
                return num
            }
            if (type === 2) {
                if (value.length < 6) {
                    return 'red'
                }
                let color = '';
                if ((!hasNumber && !hasLetter && !hasSymbol) || (hasNumber && !hasLetter && !hasSymbol) || (!hasNumber && hasLetter && !hasSymbol) || (!hasNumber && !hasLetter && hasSymbol)) {
                    color = 'red';
                }
                if ((hasNumber && hasLetter && !hasSymbol) || (!hasNumber && hasLetter && hasSymbol) || (hasNumber && !hasLetter && hasSymbol)) {
                    color = 'orange';
                }
                if (hasNumber && hasLetter && hasSymbol) {
                    color = 'green';
                }
                console.log(color)
                return color
            }
        }

    }

    render() {
        return (
            <>
                <Form
                    // layout="vertical"
                    labelCol={{span: 3}}
                    wrapperCol={{span: 21}}
                    autoComplete="off"
                >
                    <Row gutter={[20, 0]} justify="start">
                        <Col className="gutter-row" span={10}>
                            <Form.Item
                                label="账号"
                            >
                                {store.getState().data.info.username}
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={14}></Col>
                        <Col className="gutter-row" span={10}>
                            <Form.Item
                                label="原始密码"
                            >
                                <Input type="password" placeholder="请输入"
                                       value={this.state.condition.old_password ? this.state.condition.old_password : null}
                                       onChange={this.onChange.bind(this, 'old_password')}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={14}></Col>
                        <Col className="gutter-row" span={10}>
                            <Form.Item
                                label="新密码"
                                tooltip={"密码应该遵循中或强密码原则，建议采用字母+数字+特殊字符的组台，字母区分大小写。"}
                            >
                                <Input type="password" placeholder="请输入"
                                       value={this.state.condition.new_password1 ? this.state.condition.new_password1 : null}
                                       onChange={this.onChange.bind(this, 'new_password1')}/>

                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={5}>
                            <Progress strokeColor={this.getPwdValueAndColor(this.state.condition.new_password1, 2)}
                                      percent={this.getPwdValueAndColor(this.state.condition.new_password1, 1)}
                                      // showInfo={false}
                                      style={{width: 200}}
                                      format={(percent, successPercent) => {
                                          console.log(percent)
                                          if (percent === 33.33333) {
                                              return '弱'
                                          } else if (percent === 66.66666) {
                                              return '中'
                                          } else if (percent === 100) {
                                              return '强'
                                          }
                                      }}
                            />
                        </Col>
                        <Col className="gutter-row" span={10}>
                            <Form.Item
                                label="确认新密码"
                            >
                                <Input type="password" placeholder="请输入"
                                       value={this.state.condition.new_password2 ? this.state.condition.new_password2 : null}
                                       onChange={this.onChange.bind(this, 'new_password2')}/>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={14}></Col>
                        <Col className="gutter-row" span={10}>
                            <Form.Item
                                wrapperCol={{offset: 3}}
                            >
                                <Button type='primary' onClick={this.sub.bind(this)}
                                        loading={this.state.loading}>提交</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </>
        )
    }
}

export default XmView
